module.exports = __webpack_public_path__ + "img/casper.35facd85.png";